import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import { message } from 'antd';
import { updateOwner, useOwnerDetails } from 'api/owners';
import { InputUIKit as Input, FormItem, Modal, Typography, Spin } from 'ui-kit';
import { useSignedUser } from 'api/auth';

const AddPhoneModal = ({ visible, onSubmit, onClose }) => {
  const { data: user } = useSignedUser();
  const { data, isLoading, invalidate } = useOwnerDetails(user?.owner_id);
  const [formDetails, setFormDetails] = useState({
    phone: data?.phone,
  });
  const formRef = useRef();
  const handleSubmit = () => {
    formRef.current.validateFields().then((values) => {
      updateOwner({ id: user.owner_id, phone: values.phone }).then((res) => {
        if (res.ok) {
          message.success('Phone number saved successfully!');
          setFormDetails({ phone: values.phone });
          invalidate();
          onSubmit();
        } else {
          message.error(res.data || 'Error adding phone number');
        }
      });
    });
  };

  return (
    <Modal
      visible={visible}
      onOk={handleSubmit}
      onCancel={onClose}
      okText="Save"
      cancelButtonProps={{ hidden: true }}
    >
      <Spin spinning={isLoading}>
        <Typography variant="body1">
          You need to add a phone number before you can set up a payout method.
        </Typography>
        <Form
          ref={formRef}
          layout="vertical"
          initialValues={formDetails}
          className="DashboardPayouts_PayoutMethodForm"
        >
          <div className="DashboardPayouts_PayoutMethodInput">
            <FormItem
              name="phone"
              label="Phone number"
              rules={[
                {
                  required: true,
                  message: 'Please input your phone number',
                },
                {
                  transform: (value) => value.replace(/\D/g, ''),
                  pattern: /^[0-9]{10,15}$/,
                  message: 'Please input a valid phone number',
                  validateTrigger: 'onBlur',
                },
              ]}
              normalize={(value) => value.replace(/\D/g, '')}
            >
              <Input placeholder="Phone number..." maxLength={15} />
            </FormItem>
          </div>
        </Form>
      </Spin>
    </Modal>
  );
};

AddPhoneModal.propTypes = {
  visible: PropTypes.bool,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

export default AddPhoneModal;
